var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHaDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2654_61402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.65039 15H19.6504C19.8493 15 20.0401 14.921 20.1807 14.7803C20.3214 14.6397 20.4004 14.4489 20.4004 14.25V4.5C20.4004 4.30109 20.3214 4.11032 20.1807 3.96967C20.0401 3.82902 19.8493 3.75 19.6504 3.75H9.15039C8.95148 3.75 8.76071 3.82902 8.62006 3.96967C8.47941 4.11032 8.40039 4.30109 8.40039 4.5V5.25",
    stroke: "#A9A9A9",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90039 12.75L7.65039 15L9.90039 17.25",
    stroke: "#A9A9A9",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6504 9H4.65039C4.45148 9 4.26071 9.07902 4.12006 9.21967C3.97941 9.36032 3.90039 9.55109 3.90039 9.75V19.5C3.90039 19.6989 3.97941 19.8897 4.12006 20.0303C4.26071 20.171 4.45148 20.25 4.65039 20.25H15.1504C15.3493 20.25 15.5401 20.171 15.6807 20.0303C15.8214 19.8897 15.9004 19.6989 15.9004 19.5V18.75",
    stroke: "#A9A9A9",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4004 11.25L16.6504 9L14.4004 6.75",
    stroke: "#A9A9A9",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2654_61402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.150391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaDisabled);
export default __webpack_public_path__ + "static/media/HA_disabled.beca92108d8b4fae40a3ad1f1110de04.svg";
export { ForwardRef as ReactComponent };